import { FormGroup } from '@angular/forms';

import { MixpanelService } from '../_services';
import { AbstractFormComponent } from './abstract-form.component';

export abstract class MixpanelTrackedFormComponent extends AbstractFormComponent {
  constructor(form: FormGroup | undefined, protected mixpanelService: MixpanelService) {
    super(form);
  }
}



// WEBPACK FOOTER //
// ./src/app/global/mixpanel-tracked-form.component.ts